import { HttpHeaders } from '../../interceptor/interfaces';
const isRangeRequest = (headers: HttpHeaders): boolean => {
  return headers.has('range');
};
export default isRangeRequest;
